import { render, staticRenderFns } from "./BrowserCanvas.vue?vue&type=template&id=cc63aa28"
import script from "./BrowserCanvas.vue?vue&type=script&lang=js"
export * from "./BrowserCanvas.vue?vue&type=script&lang=js"
import style0 from "./BrowserCanvas.vue?vue&type=style&index=0&id=cc63aa28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports